// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"634":"51fb665c","689":"b536a0f1"}[chunkId] || chunkId) + "." + {"251":"7a8b8aeecce18ca6","634":"e4ed8cdc0714852a","689":"94146e5f3f0cc4d2"}[chunkId] + ".js";
};